import React from 'react';

import SocialsList from './Socials/SocialsList';

const Socials = () => (
  <div className="socials">
    <SocialsList />
  </div>
);

export default Socials;